import { render, staticRenderFns } from "./LinhaDeItemResumo.vue?vue&type=template&id=3f61e825&scoped=true"
import script from "./LinhaDeItemResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeItemResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeItemResumo.vue?vue&type=style&index=0&id=3f61e825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61e825",
  null
  
)

export default component.exports